<span class="fixed-top fixed_top_0">
    <div class="login_header " [ngClass]="'bg-'+globals.colorTheme">
        <a class="text-white container" routerLink="/booking">
            <span style="font-size: 20pt;">
               <strong> AGRIS Sales</strong>
            </span>
        </a>
        <br>
        <div class=" text-white" *ngIf="datasetsList.length == 0">Let's connect to your
            dataset!</div>
            <br>
            <br>
    </div>
</span>
<br>
<!-- <span class="fixed-top below_header" [ngClass]="'bg-'+globals.colorTheme">
    <div *ngIf="!selectedDataset" class="container">
        <div class="header_small"> STEP 1 of 2</div>
     
        <div class="head_smaller text-white">Please provide your
            company email and password.</div>
    </div>
    <div *ngIf="selectedDataset" class="container">
        <div class="header_small"> STEP 2 of 2</div>
        <div class="header_medium text-white">Now, let's log into the app!</div>
        <div class="head_smaller text-white">Please provide your AGRIS User Id and AGRIS Password</div>
    </div>
</span> -->
<br>

<br>
<app-login [isFromAppSettings]="true" *ngIf="selectedDataset"></app-login>
<div *ngIf="!selectedDataset">
    <div *ngIf="datasetsList.length == 0" formcontrolname style="padding-top: 100px;" class="container-fluid">
        <mat-form-field class="w-100">
            <mat-label for="agentEmail">Company Email</mat-label>
            <input placeholder="email@example.com" class="ta-appsettings-email" matInput name="agentEmail"
                [(ngModel)]="settings.agentEmail" #agentEmail="ngModel" data-hj-whitelist />
            <mat-hint>Email is case sensitive</mat-hint>
        </mat-form-field>
        <br>
        <mat-form-field class="w-100">
            <mat-label for="password">Password</mat-label>
            <input matInput class="ta-appsettings-password" type="password" name="password"  [type]="hide ? 'password' : 'text'"
                [(ngModel)]="settings.agentPassword" #password="ngModel" />
            <mat-icon matSuffix (click)="hide = !hide">{{hide ? 'visibility_off' : 'visibility'}}</mat-icon>
            <mat-hint>Password is case sensitive</mat-hint>
        </mat-form-field>
        <br><br>
        <button mat-button [disabled]="!settings.agentEmail || !settings.agentPassword"
            [ngClass]="'ta-login-login w-100 text-white btn btn-'+globals.colorTheme" (click)="connect()">Load 
            Datasets</button>
        <br>
        <br>
        <!-- <div *ngIf="datasetsList.length==0 && alreadySeletecdDataset" class="text-center">
            <a class="link_black ta-appsettings-close magin_5 w-100" routerLink="/login">Back to log in screen</a>
        </div> -->
    </div>
    <br>
    <div>
        <ng-container *ngIf="!selectedDataset">
            <br>
            <br>

            <div *ngIf="datasetsList.length > 0"  [ngClass]="'text-'+globals.colorTheme" class="pt-6 " id="topContainer">
                <div class="p-2 ">
                    <h4 >
                        Welcome to Agent login,
                    </h4>
                    <div>
                        Please select your dataset.
                    </div>
                </div>
            </div>
            <br>
            <br>

            <div *ngFor="let dataset of datasetsList">
                <mat-card class="mat-mdc-card-padding16" appearance="outlined" (click)="selectDataset(dataset)" style=" font-family: Roboto;"
                    [ngClass]="'ta-appsettings-'+dataset.TenantCode.toLowerCase()">
                    <!-- <div mat-card-avatar class="fa fa-database fa-3x"></div> -->
                    <div style="font-size: 16px;"><strong> {{dataset.TenantName}}</strong></div>
                    <!-- <div [style.display]="dataset.TenantCode != '' ? 'block' : 'none'">{{dataset.TenantCode}}</div> -->
                    <div [style.display]="dataset.Description != '' ? 'block' : 'none'">{{dataset.Description}}
                        <div class="text-center magin_5"> <a class="link_green ta-appsettings-close ">
                                Connect</a>
                        </div>
                    </div>
                </mat-card>
                <br>
            </div>
        </ng-container>
    </div>
</div>